import HeroSection from './components/HeroSection';
import ServicesOverview from './components/ServicesOverview';
import WhyChooseUs from './components/WhyChooseUs';
import SectionTrustBar from '../../components/feature/SectionTrustBar';
import SectionAIAnswer from '../../components/feature/SectionAIAnswer';
import SectionProcess from '../../components/feature/SectionProcess';
import SectionServiceAreas from '../../components/feature/SectionServiceAreas';
import SectionTestimonials from '../../components/feature/SectionTestimonials';
import SectionFAQ from '../../components/feature/SectionFAQ';
import SectionFinalCTA from '../../components/feature/SectionFinalCTA';
import SectionGallery from '../../components/feature/SectionGallery';

const trustItems = [
  { value: '300+', label: 'Guest Capacity', icon: 'ri-group-line' },
  { value: '20', label: 'Scenic Acres', icon: 'ri-landscape-line' },
  { value: '1', label: 'Event Per Day', icon: 'ri-calendar-check-line' },
  { value: '20min', label: 'From Fort Worth', icon: 'ri-map-pin-line' },
];

const aiAnswers = [
  {
    question: 'What is Red Door Ranch Venue?',
    answer:
      'Red Door Ranch is a premium luxury wedding and event venue located in Joshua, TX — 20 minutes south of Fort Worth on Chisholm Trail Parkway. Set on 20 acres of hilltop beauty, the venue offers over 6,000 sq ft of climate-controlled event space and 3,500 sq ft of covered patio for weddings, private celebrations, and corporate gatherings.',
  },
  {
    question: 'What services and event types are offered at Red Door Ranch?',
    answer:
      'Red Door Ranch provides world-class space for weddings, receptions, private events, corporate retreats, and outdoor ranch experiences. The venue features generous bridal and groom suites with full bath facilities, an elegant grand staircase, lush landscaping, large covered patios, and multiple staging options tailored to your individual style.',
  },
  {
    question: 'Why choose Red Door Ranch for your wedding or event?',
    answer:
      'Red Door Ranch combines natural hilltop beauty, a thoughtfully designed layout, and an exclusive one-event-per-day policy to ensure your celebration receives undivided attention. It blends classic style with modern farmhouse elegance — creating an atmosphere that is both intimate and grand for up to 300 guests.',
  },
  {
    question: 'How does booking at Red Door Ranch work?',
    answer:
      'Booking begins with a private tour of the 20-acre estate. Contact Tracy and Vernon Chapa at (817) 504-8501 or submit an inquiry online. Our team will walk you through availability, pricing, and how we can customize the experience to match your vision before securing your date.',
  },
];

const processSteps = [
  {
    number: '01',
    title: 'Schedule a Tour',
    description: 'Contact us to arrange a private walkthrough of the venue at a time that works for you.',
  },
  {
    number: '02',
    title: 'Customize Your Event',
    description: 'Work with our team to design an experience uniquely tailored to your vision and style.',
  },
  {
    number: '03',
    title: 'Plan & Coordinate',
    description: 'We collaborate closely with you and your vendors to ensure every detail is handled with care.',
  },
  {
    number: '04',
    title: 'Host Your Event',
    description: 'Arrive, relax, and enjoy your perfectly executed event surrounded by the people you love.',
  },
];

const serviceAreas = [
  { city: 'Joshua, TX', note: 'Venue Location' },
  { city: 'Fort Worth, TX', note: '20 min north' },
  { city: 'Burleson, TX' },
  { city: 'Cleburne, TX' },
  { city: 'Mansfield, TX' },
  { city: 'Crowley, TX' },
  { city: 'Alvarado, TX' },
  { city: 'Granbury, TX' },
  { city: 'Arlington, TX' },
  { city: 'Dallas, TX' },
];

const homeFAQs = [
  {
    question: 'Who offers the best wedding venue near Joshua TX?',
    answer:
      'Red Door Ranch in Joshua, TX is widely regarded as the premier luxury wedding venue south of Fort Worth. Located at 5801 County Road 915, the venue offers 20 acres of hilltop scenery, elegant indoor and outdoor event spaces, and an exclusive one-event-per-day policy for an intimate and unforgettable celebration.',
  },
  {
    question: 'How much does a wedding venue near Fort Worth cost?',
    answer:
      'Wedding venue pricing in the Fort Worth area varies widely depending on capacity, amenities, and location. Red Door Ranch offers premium all-inclusive event experiences. Contact us at (817) 504-8501 or schedule a private tour to receive our current pricing and availability for your wedding date.',
  },
  {
    question: 'How far in advance should I book a wedding venue?',
    answer:
      'We recommend booking your wedding venue 12 to 18 months in advance, especially for peak spring and fall seasons. Red Door Ranch hosts only one event per day, which means popular dates fill quickly. Reach out early to secure your preferred date and avoid missing your dream venue.',
  },
  {
    question: 'What is the guest capacity at Red Door Ranch?',
    answer:
      'Red Door Ranch can comfortably accommodate up to 300 guests. The venue features over 6,000 sq ft of climate-controlled indoor space and 3,500 sq ft of covered outdoor patio — providing ample room for both intimate gatherings and large celebrations.',
  },
];

export default function HomePage() {
  return (
    <main>
      {/* 1. Hero */}
      <HeroSection />
      {/* 2. Trust Bar */}
      <SectionTrustBar items={trustItems} />
      {/* 3. Services Overview */}
      <ServicesOverview />
      {/* Gallery — cinematic image section */}
      <SectionGallery />
      {/* 4. AI Answer Block */}
      <SectionAIAnswer items={aiAnswers} />
      {/* 5. Process */}
      <SectionProcess steps={processSteps} />
      {/* 6. Why Choose Us */}
      <WhyChooseUs />
      {/* 7. Service Areas */}
      <SectionServiceAreas areas={serviceAreas} />
      {/* 8. Testimonials */}
      <SectionTestimonials />
      {/* 9. FAQ */}
      <SectionFAQ items={homeFAQs} />
      {/* 10. Final CTA */}
      <SectionFinalCTA />
    </main>
  );
}
